<template>
  <div class="chooseImg">
    <div v-for="(item, index) in fileList" :key="index" class="file" :style="{ width: width + 'px', height: height + 'px' }">
      <vue-hover-mask>
        <img :src="item.url"  :style="{ width: width + 'px', height: height + 'px'}"/>
        <template v-slot:action>
          <i class="el-icon-view" style="margin: 0 4px" @click="handlePreview(item)" />
          <i class="el-icon-delete" style="margin: 0 4px" @click="handleDel(item)" />
        </template>
      </vue-hover-mask>
    </div>
    <el-upload v-if="fileList.length<limit" action="#" :http-request="http_request" list-type="picture-card" :show-file-list="false" :accept="accept"  :style="{ width: width + 'px', height: height + 'px' }">
      <div :style="{ width: width + 'px', height: height + 'px' }" class="uplaodBtn" v-loading="spinning">
        <div>
           <el-image :src="require('@/assets/uploadTop.png')" fit="cover" style="width:25px;height:25px" />
          <div class="ant-upload-text">点击上传</div>
        </div>
      </div>
    </el-upload>
    <el-dialog :visible.sync="previewVisible" width="600px" title="预览" append-to-body>
      <div class="previewImage">
        <img :src="previewImage" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
	uploadAPI
} from "@/api/submit"
import vueHoverMask from "vue-hover-mask"
export default {
  components: {
	vueHoverMask
  },
  props: {
    // 允许上传的图片类型
    accept: {
      type: String,
      default: "image/*",
    },
    width: {
      type: Number,
      default: 120,
    },
    height: {
      type: Number,
      default: 120,
    },
    isAllValue: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    value: {
      type: [Array, String, Object],
      default: "",
    },
    path: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      spinning: false,
      fileList: [],
      previewVisible: false,
      previewImage: "",
      uplaodBtnStyle: {
        width: this.width + "px",
        height: this.height + "px",
      },
    };
  },
  watch: {
    // 正向-变化值
    value() {
      if (Array.isArray(this.value)) {
        this.fileList = this.value.map((v) => {
          if (typeof v == "string" && v.constructor == String) {
            return { url: v };
          } else {
            return v;
          }
        });
      } else {
        if (this.value) {
          this.fileList = [{ url: this.value }];
        } else {
          this.fileList = [];
        }
      }
    },
  },
  mounted() {
    // 正向-默认值
    if (Array.isArray(this.value)) {
      this.fileList = this.value.map((v) => {
        if (typeof v == "string" && v.constructor == String) {
          return { url: v };
        } else {
          return v;
        }
      });
    } else {
      if (this.value) {
        this.fileList = [{ url: this.value }];
      } else {
        this.fileList = [];
      }
    }
  },
  methods: {
    //删除
    handleDel(val) {
      this.fileList.map((v, i) => {
        if (v.url == val.url) {
          this.fileList.splice(i, 1);
          this.setValue();
        }
      });
    },
    //预览
    handlePreview(val) {
      this.previewImage = val.url;
      this.previewVisible = true;
    },
    setValue() {
      let val;
      if (this.limit == 1) {
        if (this.isAllValue) {
          val = this.fileList.length ? this.fileList[0] : {};
        } else {
          val = this.fileList.length ? this.fileList[0].url : "";
        }
      } else {
        if (this.isAllValue) {
          val = this.fileList.map((v) => {
            return v;
          });
        } else {
          val = this.fileList.map((v) => {
            return v.url;
          });
        }
      }

      if (JSON.stringify(val) !== JSON.stringify(this.value)) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },
    http_request({ file }, type) {
      console.log(file,'file')
      this.spinning = true;
       let form = new FormData();
      form.append("file", file);
      form.append("prefix", this.path);

      uploadAPI(form)
        .then((res) => {
          this.fileList.push({url:res.data,fileName:this.getFileType(file.name)  });
          this.setValue();
        })
        .finally(() => {
          this.spinning = false;
        });

    },
     getFileType(fileName) {
      var startIndex = fileName.lastIndexOf(".");
      return fileName.substring(0, startIndex)
    },
  },
};
</script>

<style lang="scss" scoped>
.uplaodBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  .ant-upload-text {
    color: #999;
    margin-top: 4px;
  }
}
::v-deep {
  .el-upload--picture-card {
    width: 100%;
    height: 100%;
    line-height: 1;
  }
}
.chooseImg {
  display: flex;
  flex-wrap: wrap;
}
.previewImage {
  // padding: 15px;
  width: 100%;
  img {
    width: 100%;
  }
}
.file {
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  border: 1px dashed #c0ccda;
  cursor: pointer;
  //   vertical-align: top;
  background-color: #fbfdff;
  // padding: 8px;
  //   box-sizing: border-box;
  img {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
